import { RefObject } from 'react'

import { Virtualizer } from '@tanstack/react-virtual'

import { useTranscriptParagraphIds } from 'src/contexts/Transcript/TranscriptContext'
import { useActiveMediaTimingEvent } from 'src/hooks/useActiveMediaTiming'

export const useMediaPlaybackFollow = (listRef: RefObject<Virtualizer<HTMLDivElement, Element> | null>) => {
    const paragraphIds = useTranscriptParagraphIds()

    useActiveMediaTimingEvent((activeTiming) => {
        if (!activeTiming?.paragraphId) {
            return
        }

        // Only scrolls: selecting the playing paragraph would open it in the editor.
        const paragraphIndex = paragraphIds.indexOf(activeTiming.paragraphId)
        if (paragraphIndex !== -1) {
            listRef.current?.scrollToIndex(paragraphIndex)
        }
    })
}
